import { Header, SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import TableBookings from '../../../../../components/tables/tableBookings';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';


import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemBooking } from '../../../../../resources/types';
dayjs.extend(isBetween);

export const MembersBookingsGridPage = () => {

    const { menu, parameters } = useGlobalState();

    const [bookings, setBookings] = useState<ItemBooking[]>([]);




    const handleRefresh = async () => {
        if (parameters && parameters.date && parameters.date !== "") {
            try {
                setBookings([]);
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/bookings/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        dateBetween: parameters.date,
                        orderBy: "ordenGroupType",
                        order: "ASC",
                        orderBy2: "dateEnd",
                        order2: "ASC"
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.bookings) {
                    setBookings(data.bookings)
                }
                //storeAdmin(data);
                // Create a new list with updated 'accesos' field before setting it to state

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };
    const handleDeleteBooking = async (idBooking: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/bookings/delete',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idBooking: idBooking,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data) {
                if (data.code === 0) {
                    addNotification(data.status, "success", setData)
                    handleRefresh()
                } else {
                    addNotification(data.status, "error", setData)
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (parameters.date != "") {
            handleRefresh();
        }
    }, [parameters.date]);

    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">


                    <Header actions={


                        <Favorites />
                    }>Reservas
                    </Header>

                    {
                        bookings && (
                            <>
                                <SpaceBetween direction="horizontal" size="xs">


                                </SpaceBetween>

                                <TableBookings

                                    bookingUrl={"members/bookings/book"}

                                    onBookingDelete={(booking) => {
                                        handleDeleteBooking(booking.idBooking)
                                    }}
                                    filter={
                                        <DPModal today date={parameters.date} clear={false} tomorrow onConfirm={(date) => {
                                            if (date !== "") {
                                                const updatedParameters = {
                                                    ...parameters, // clone existing keys
                                                    date: (date) // add or update
                                                };
                                                setParameters(updatedParameters);
                                            }
                                        }} />
                                    }
                                    canDelete date={parameters.date} bookings={bookings} visible={true} onBookingClick={(book: ItemBooking) => { }} />
                            </>
                        )
                    }
                </SpaceBetween >
            }
        />

    );
};